import { ITask } from '@modules/TasksModule/types';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import { InboxContext } from '../types';
import getTransferStatus from '@api/queries/getTransferStatus';
import { CallTransferStatus } from '@api/generated/graphql';
import TasksModule from '@modules/TasksModule';
import ToastModule from '@modules/ToastModule';

async function handleTaskTransfer(
  context: InboxContext,
  task: ITask,
): Promise<void> {
  const featureInboxCallWarmTransfers = FeatureFlagModule.isEnabled(
    FeatureFlagKeys.featureInboxCallWarmTransfers,
  );
  // early return in case of no transferStatus, not in progress or warm transfers enabled (handled by TransfersModule)
  if (
    !task.attributes.transferStatus ||
    !task.attributes.transferStatus.inProgress ||
    featureInboxCallWarmTransfers
  ) {
    return;
  }

  const status = await getTransferStatus(
    task.id,
    task.attributes.transferStatus.agentId,
  );
  if (
    status === CallTransferStatus.Unknown ||
    status === CallTransferStatus.InProgress
  ) {
    // unknown: it's possible that conversation has not been updated just yet
    // in progress: it's possible that the call is still ringing for the transferee
    setTimeout(() => {
      handleTaskTransfer(context, task);
    }, 10000);
  } else if (status === CallTransferStatus.Failure) {
    // we know that the transfer is failed, show error toast and keep close&classify
    // as is
    TasksModule.setTaskAttribute(task.id, 'transferStatus', {
      ...task.attributes.transferStatus,
      inProgress: false,
    });
    ToastModule.showToast({
      title: 'Call transfer failed',
      status: 'critical',
      duration: 5000,
    });
  } else if (status === CallTransferStatus.Successful) {
    // we know that the transfer is successful, show success toast
    // and set task status to completed with close and classify properly set
    TasksModule.setTaskAttribute(task.id, 'transferStatus', {
      ...task.attributes.transferStatus,
      inProgress: false,
    });
    // no need to complete the task (if completed, this would prevent
    // the second agent from close-classifying as we would set the interaction record)
    TasksModule.deleteTask(task.id);
    ToastModule.showToast({
      title: 'Call Transferred',
      status: 'success',
      duration: 5000,
    });
  }
}

export default handleTaskTransfer;
